import { c as _c } from "react/compiler-runtime";
interface LegendItemProps {
  color: string;
  label: string;
}
function LegendItem(t0) {
  const $ = _c(7);
  const {
    color,
    label
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <span className="inline-block size-2.5 rounded-full" style={{
      backgroundColor: color
    }} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="text-muted-foreground text-sm font-semibold">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center gap-2">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export { LegendItem };